export default "__VITE_ASSET__Dqkn$pbs__"